<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { formatDayMonth } from '@/utils/format'

import BFeedbackPage from '@/components/base/BFeedbackPage/BFeedbackPage.vue'

// Feedback window of the amortization dialog (ADA-4437 etapp 5), on the shared BFeedbackPage
// (the feedback pattern Anton approved for the respite dialog in etapp 4). The date is the
// plan's first payment day from the submitted payload.
const { feedback, date } = defineProps<{
  feedback: 'success' | 'failed' | null
  date: Date | null
}>()

const emit = defineEmits<{ close: [] }>()

const { t } = useI18n()

const title = computed(() => (feedback != null ? t(`common.amortization_${feedback}_title`) : ''))
const formattedDate = computed(() => (date != null ? formatDayMonth(date) : ''))
</script>

<template>
  <b-feedback-page
    :feedback="feedback"
    :title="title"
    :button-text="t('common.return_to_debts')"
    @close="emit('close')"
  >
    <i18n-t
      v-if="feedback === 'success'"
      keypath="common.amortization_success_text"
      tag="span"
    >
      <span class="font-weight-bold">{{ formattedDate }}</span>
    </i18n-t>
    <template v-else-if="feedback === 'failed'">{{ t('common.amortization_failed_text') }}</template>
  </b-feedback-page>
</template>
